import { ResourcesSelectionEditor } from '@/components/resourcesSelection/resourcesSelectionEditor';
import { StepContainer } from '@/components/wizard/StepContainer';
import type { StepProps } from '@/components/wizard/StepProps';
import { hasValidConditionValues } from '@/types/advanceFilter';

import { useRansomwareSupportedProperties } from './assignRansomwareByCondition';
import type { RansomwareByConditionState } from './ransomwareByConditionFlow';

export const ransomwareConditionEditorAllExcludedDescription =
  'Current and future supported resources from your connected source accounts will be added to the ransomware detection plan.';
export const ransomwareConditionEditorAllIncludedDescription =
  'Current and future resources from your connected source accounts will be excluded from the ransomware detection plan.';

export const RansomwareConditionEditor = (
  props: StepProps<RansomwareByConditionState>
) => {
  const ransomwareSupportedProperties = useRansomwareSupportedProperties();
  return (
    <>
      <StepContainer
        hideStepper
        onBackClick={props.back}
        canGoNext={() =>
          props.wizardState.resourcesScopeType !== 'useConditions' ||
          hasValidConditionValues(props.wizardState.condition)
        }
        nextButtonText={props.wizardState.editMode ? 'Save Changes' : 'Create'}
        backButtonText='Cancel'
        sx={{ padding: 0, height: '100%' }}
        onNextClick={() => props.finish()}
      >
        <ResourcesSelectionEditor
          condition={props.wizardState.condition}
          setCondition={(condition) =>
            props.setWizardState({ ...props.wizardState, condition })
          }
          supportedProperties={ransomwareSupportedProperties}
          conditionTitle='Check resources meeting these conditions for ransomware:'
          allExcludedDescription={
            ransomwareConditionEditorAllExcludedDescription
          }
          allIncludedDescription={
            ransomwareConditionEditorAllIncludedDescription
          }
          manualOverridesDescription='Manually include or exclude resources from your ransomware plan, regardless of dynamic selection.'
          includedResources={props.wizardState.include ?? []}
          excludedResources={props.wizardState.exclude ?? []}
          setIncludedResources={(includedResources) =>
            props.setWizardState({
              ...props.wizardState,
              include: includedResources,
            })
          }
          setExcludedResources={(excludedResources) =>
            props.setWizardState({
              ...props.wizardState,
              exclude: excludedResources,
            })
          }
          resourcesScopeType={props.wizardState.resourcesScopeType}
          setResourcesScopeType={(resourcesScopeType) =>
            props.setWizardState({
              ...props.wizardState,
              resourcesScopeType,
            })
          }
        />
      </StepContainer>
    </>
  );
};
